import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import React from 'react';
import type { BaseChildProps } from './type';
interface Props {
  stepList: string[];
  step: number;
  className?: string;
  itemClassName?: string;
  children: React.ReactNode;
}
function BaseStep(t0) {
  const $ = _c(25);
  const {
    step,
    stepList,
    className,
    itemClassName,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("relative", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== step || $[3] !== stepList) {
    let t3;
    if ($[5] !== step) {
      t3 = (item, index) => <div key={item} className="relative flex flex-col items-center"><div className="absolute top-[35%] left-0 z-[0] h-[1px] w-[calc(100%-80px)]"><div className="h-[1px] w-full border-borderBg15 border-b-2" /></div><div className={cn("z-[1] mb-3 flex h-[80px] w-[80px] flex-col items-center justify-center rounded-full border-2 border-borderBg15 bg-baseBg text-[12px]", {
          "border-none bg-primaryBg": step === index
        })}><span className={cn("font-medium text-colorFg09", {
            "text-colorFg12": step === index
          })}>STEP</span><span className={cn("mt-1 font-bold font-nanum-square text-[24px] text-colorFg18 leading-[1]", {
            "text-colorFg12": step === index
          })}>0{index + 1}</span></div><div className={cn("text-center font-medium text-[#777]", {
          "text-primaryFg": step === index
        })}>{item}</div></div>;
      $[5] = step;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = stepList.map(t3);
    $[2] = step;
    $[3] = stepList;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="mb-[70px] flex-col"><div className="flex items-center justify-center [&>*:not(:first-child)]:pl-[135px]">{t2}</div></div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== itemClassName) {
    t4 = cn("w-full", itemClassName);
    $[9] = itemClassName;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== children || $[12] !== step || $[13] !== stepList) {
    let t6;
    if ($[15] !== step || $[16] !== stepList) {
      t6 = child => React.isValidElement(child) ? React.cloneElement(child, {
        activeStep: stepList[step]
      }) : child;
      $[15] = step;
      $[16] = stepList;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    t5 = React.Children.map(children, t6);
    $[11] = children;
    $[12] = step;
    $[13] = stepList;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[18] !== t4 || $[19] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t1 || $[22] !== t3 || $[23] !== t6) {
    t7 = <div className={t1}>{t3}{t6}</div>;
    $[21] = t1;
    $[22] = t3;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
}
export default BaseStep;